import { Badge } from '@cocoonspace/ui/components/badge'
import dayjs from 'dayjs'
import { ClockIcon } from 'lucide-react'

export const Duration = ({ duration }: { duration: number }) => (
	<>
		<ClockIcon />

		{duration < 60
			? `${duration} min`
			: dayjs
					.duration(duration, 'minutes')
					.format('H[h]mm')
					.replace('h00', 'h')}
	</>
)

export const DurationBadge = ({
	duration,
	...props
}: {
	duration: number
} & React.ComponentProps<typeof Badge>) => (
	<Badge
		className='flex items-center gap-1'
		variant='outline'
		{...props}
	>
		<Duration duration={duration} />
	</Badge>
)
